export enum Gender {
  BOTH = 1,
  MALE = 2,
  FEMALE = 3,
}
